function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import Draggable from 'react-draggable';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import XIcon from 'svg/x.svg';
import HandIcon from 'svg/hand.svg';
import App from 'modules/App';
import { getPosition } from './helpers';
var _React_PureComponent;
class FloatingModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { floatingModal } = props;
        if (floatingModal && !state.position) {
            const position = getPosition(floatingModal);
            return {
                position
            };
        }
        if (!floatingModal && state.position) {
            return {
                position: null
            };
        }
        return null;
    }
    onActivate() {
        const { floatingModalId } = this.props.floatingModal || {};
        this.props.onActivate(floatingModalId);
    }
    onClose(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (!this.props.onClose || this.props.isInProgress || this.props.isDisabled) {
            return;
        }
        this.props.onClose();
    }
    get isActive() {
        const { floatingModalId } = this.props.floatingModal || {};
        return floatingModalId === this.props.activeFloatingModalId;
    }
    get isOpen() {
        return this.props.floatingModal;
    }
    renderGrabBtn() {
        if (this.props.isFixed) {
            return null;
        }
        return(// eslint-disable-next-line jsx-a11y/control-has-associated-label
        /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: "modal__btn modal__btn--grab",
            children: /*#__PURE__*/ _jsx("span", {
                className: "btn-inner",
                children: /*#__PURE__*/ _jsx(HandIcon, {
                    className: "modal__btn__icon"
                })
            })
        }));
    }
    renderCloseBtn() {
        if (!this.props.onClose) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal__controls modal__controls--floating",
            children: [
                this.renderGrabBtn(),
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "modal__btn",
                    onClick: (evt)=>this.onClose(evt),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "btn-inner",
                        children: /*#__PURE__*/ _jsx(XIcon, {
                            className: "modal__btn__icon"
                        })
                    })
                })
            ]
        });
    }
    renderHeader() {
        if (!this.props.headerMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("h2", {
                className: "modal__header modal__header--floating",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, this.props.headerMessage))
            })
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn('modal__contentWrapper', {
                'mt-5': !this.props.onClose
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "modal__content modal__content--floating",
                children: [
                    this.renderHeader(),
                    this.props.children
                ]
            })
        });
    }
    renderModal() {
        if (!this.isOpen) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Draggable, {
            handle: ".modal__btn--grab",
            disabled: this.props.isFixed,
            onStart: ()=>this.onActivate(),
            children: /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    ease: 'easeOut',
                    duration: 0.15
                },
                className: cn('modal modal--floating', {
                    'modal--active': this.isActive,
                    'modal--docked': this.props.isDocked,
                    [`modal--${this.props.styleModifier}`]: this.props.styleModifier
                }, this.props.className),
                style: this.state.position,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "modal__body modal__body--floating",
                    children: [
                        this.renderCloseBtn(),
                        this.renderContent()
                    ]
                })
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(AnimatePresence, {
            children: this.renderModal()
        });
    }
    constructor(props){
        super(props);
        this.state = {
            position: null
        };
    }
}
_define_property(FloatingModal, "propTypes", {
    // Explicit props
    floatingModal: App.shapes.floatingModal,
    activeFloatingModalId: PropTypes.string,
    styleModifier: PropTypes.oneOf([
        'md',
        'lg',
        'xl'
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    headerMessage: PropTypes.object,
    children: PropTypes.node,
    isInProgress: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isDocked: PropTypes.bool,
    isFixed: PropTypes.bool,
    // Explicit actions
    onActivate: PropTypes.func,
    onClose: PropTypes.func
});
_define_property(FloatingModal, "defaultProps", {
    isInProgress: false,
    isDisabled: false,
    isDocked: false,
    isFixed: false
});
const mapStateToProps = (state)=>({
        activeFloatingModalId: App.selectors.activeFloatingModalId(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onActivate: (floatingModalId)=>dispatch(App.actions.activateFloatingModal(floatingModalId))
    });
const ConnectedFloatingModal = connect(mapStateToProps, mapDispatchToProps)(FloatingModal);
export default ConnectedFloatingModal;
